import { useMutation, useQueryClient } from 'react-query'
import { useSnackbar } from 'notistack'
import { createCustomerGroup } from 'services/cm-api/create-customer-group'
import { WebApi2Response, CustomerGroupT } from 'types/global'

/**
 * Wraps `POST /customer-group`. The CMAPI returns 400 on duplicate
 * name (case-insensitive uniqueness) and on an empty `customer_ids`
 * array — we surface either as a snackbar. Successful creates
 * invalidate the list query and emit a success snackbar.
 */
export function useCreateCustomerGroup() {
  const queryClient = useQueryClient()
  const { enqueueSnackbar } = useSnackbar()

  return useMutation(createCustomerGroup, {
    onSuccess: async (response: WebApi2Response<CustomerGroupT>) => {
      if (response.success) {
        enqueueSnackbar(`Customer group "${response.data.name}" created`, {
          variant: 'success',
        })
        await queryClient.invalidateQueries(['getCustomerGroups'])
      }
    },
    onError: (err: unknown) => {
      const axiosErr = err as {
        response?: { data?: { error?: { message?: string } } }
      }
      const apiMessage = axiosErr?.response?.data?.error?.message
      enqueueSnackbar(apiMessage ?? 'Failed to create customer group', {
        variant: 'error',
      })
      console.error('createCustomerGroup failed: ', err)
    },
  })
}
